import styled from '@emotion/styled'
import { CSSProperties } from 'react'

import { THEMES } from '@/constants'
import useTheme from '@/hooks/useTheme'
import { ReactComponent as BlackLogo } from '@/vendor/logo-black.svg'
import { ReactComponent as WhiteLogo } from '@/vendor/logo-white.svg'

const Logo = styled.div`
  width: 80%;
  max-width: 440px;
  height: 64px;
  svg {
    width: 100%;
    height: 100%;
  }
`

function DaiLogo({ sx }: { sx?: CSSProperties }) {
  const { theme } = useTheme()
  const darkMode = theme === THEMES.DARK
  return <Logo style={sx}>{darkMode ? <WhiteLogo /> : <BlackLogo />}</Logo>
}

export default DaiLogo
